module.exports = __webpack_public_path__ + "static/media/INTRODUCTION TO DASHBOARD BI (BUSINESS INSIGHTS).65672ed2.png";